import axios from './ConfiguredAxios';
import App from 'PublicJs/App';

const Projects = {

	getFeatured() {
		return axios.get(App.getLocale() + '/projects/featured');
	},

	lookupSlug: (name) => {
		let url = '/admin/projects/lookupSlug';
		return axios.get(url, {
			params: {
				q: name
			}
		});
	},

	getImages: (projectId) => {
		return axios.get( '/projects/images/' + projectId);
	},

	deletePhoto: (photoId) => {
		return axios.delete('/files/delete/Projects/' + photoId);
	},

	getPhotoElementHtml(photoId, iterator) {
		let url = '/projects/photoFormElement/' + photoId + '/' + iterator;

		return axios.get(url, {
			headers: {
				'Accept': 'text/html'
			}
		});
	},

	getPartnerCompaniesHtml() {
		let url = '/projects/partnerCompaniesTemplate';

		return axios.get(url, {
			headers: {
				'Accept': 'text/html'
			}
		});
	}
};

export default Projects;
